import React from 'react'

import { makeStyles } from 'tss-react/mui'

import { Theme } from '@mui/material'

import { cx } from 'tss-react/@emotion/css'

import { DebouncedTextFilter } from '../../../../components/DebouncedTextFilter'
import { ScoutingCampaignListFilters, ScoutingCampaignStatus } from '../../../../../../entities-next/scoutingCampaign'
import { ScoutingCampaignStatusSelector } from './ScoutingCampaignStatusSelector.component'

export type ScoutingCampaignFiltersProps = {
  className?: string
  filters: ScoutingCampaignListFilters
  onChange: (filters: ScoutingCampaignListFilters) => void
}

export function ScoutingCampaignFilters({ className, filters, onChange }: ScoutingCampaignFiltersProps) {
  const { classes } = useStyles()
  const handleIdChange = (id: string) => {
    onChange({ ...filters, ids: id ? [Number(id)] : undefined })
  }
  const handleCorporateIdChange = (corporateId: string) => {
    onChange({ ...filters, corporateId: Number(corporateId) })
  }
  const handleNameChange = (name: string) => {
    onChange({ ...filters, search: name })
  }

  const handleStatusChange = (status: ScoutingCampaignStatus) => {
    onChange({ ...filters, status })
  }
  return (
    <div className={cx(className, classes.filterList)}>
      <DebouncedTextFilter defaultValue={filters.ids?.[0]?.toString()} placeholder="Id..." onChange={handleIdChange} />
      <DebouncedTextFilter
        defaultValue={filters.corporateId?.toString()}
        placeholder="Corporate id..."
        onChange={handleCorporateIdChange}
      />
      <DebouncedTextFilter defaultValue={filters.search} placeholder="Name..." onChange={handleNameChange} />
      <ScoutingCampaignStatusSelector status={filters.status} onChange={handleStatusChange} />
    </div>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  filterList: {
    display: 'flex',
    gap: spacing(2),
  },
}))
